import { useEffect, useState } from "react";
import { parseAviationAssignment } from "./aviationOrderPayload";

export default function useAviationAssignment(order) {
  const [form, setForm] = useState(() => parseAviationAssignment());
  useEffect(() => {
    if (order) setForm(parseAviationAssignment(order));
  }, [order]);
  const setField = (key) => (value) => setForm((previous) => ({ ...previous, [key]: value }));
  return {
    ...form,
    setTnvedCode: setField("tnvedCode"),
    setUnitMeasurement: setField("unitMeasurement"),
    setAssignmentMethod: setField("assignmentMethod"),
    setIncoterms: setField("incoterms"),
    setIncotermsEnabled: setField("incotermsEnabled"),
    setAuctionStep: setField("auctionStep"),
    setExtendAuction: setField("extendAuction"),
  };
}
